module.exports = __webpack_public_path__ + "img/ry_gray.ea575866.png";